import { render } from "./WildBookObserveData.vue?vue&type=template&id=8812a808&scoped=true&ts=true"
import script from "./WildBookObserveData.vue?vue&type=script&lang=ts"
export * from "./WildBookObserveData.vue?vue&type=script&lang=ts"

import "./WildBookObserveData.vue?vue&type=style&index=0&id=8812a808&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8812a808"]])

export default __exports__